const ESCAPE_MAP = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
};

const REVERSE_ESCAPE_MAP = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
};

export const stripHtmlTags = (htmlSanitizer, htmlString) =>
  htmlSanitizer(htmlString, { allowedTags: [] });

export const escapeHtml = (htmlString) =>
  htmlString.replace(
    /[&<>]/g,
    (characterToEscape) => ESCAPE_MAP[characterToEscape] || characterToEscape
  );

export const unescapeHtml = (str) =>
  str.replace(/&lt;|&gt;|&amp;/g, (tag) => REVERSE_ESCAPE_MAP[tag] || tag);

export const html2text = (htmlSanitizer, htmlString) =>
  unescapeHtml(stripHtmlTags(htmlSanitizer, htmlString));
